import React, { useState, useEffect } from "react";
import createBoard from "../../util/Minesweeper/createboard";
import Cell from "./Cell";
import { revealed } from "../../util/Minesweeper/reveal";
import TopBar from "./TopBar";
import Modal from "./Modal";
import '../../stylesheet/Minesweeper.css';

export default function Board() {
    const [board, setBoard] = useState([]);
    const [mineLocations, setMineLocations] = useState([]);
    const [nonMinesCount, setNonMinesCount] = useState(0);
    const [gameOver, setGameOver] = useState(false);
    const [flag, setFlag] = useState(0);
    const [restart, setRestart] = useState(false);
    const [newTime, setTime] = useState(0);

    useEffect(() => {
        const generateBoard = () => {
            let row, col, bombs;
            let width = window.innerWidth;
            if (width >= 2560) {
                row = 19;
                col = 64;
                bombs = 50;
            } else if (width >= 1800) {
                row = 15;
                col = 48;
                bombs = 40;
            } else if (width >= 1340) {
                row = 14;
                col = 40;
                bombs = 30;
            }  else if (width >= 1024) {
                row = 14;
                col = 30;
                bombs = 25;
            } else if (width >= 768) {
                row = 12;
                col = 23;
                bombs = 20;
            } else if (width >= 425) {
                row = 12;
                col = 13;
                bombs = 15;
            } else if (width >= 375) {
                row = 10;
                col = 10;
                bombs = 12;
            } else {
                row = 9;
                col = 9;
                bombs = 12;
            }
            
            const getBoard = createBoard(row, col, bombs, setMineLocations);
            setNonMinesCount(row * col - bombs);
            setTime(0);
            setBoard(getBoard.board);
            setMineLocations(getBoard.mineLocation);
            setGameOver(false);
            setRestart(false);
            setFlag(bombs);
        };
        generateBoard();
    }, [restart, setRestart]);

    const updateBoard = (x, y, e) => {
        let newBoardValues = JSON.parse(JSON.stringify(board));
        let newNonMinesCount = nonMinesCount;
        if (newBoardValues[x][y].value === "X") {
            for (let i = 0; i < mineLocations.length; i++) {
                if (
                    !newBoardValues[mineLocations[i][0]][mineLocations[i][1]].revealed
                ) {
                    // setInterval(() => {
                    newBoardValues[mineLocations[i][0]][
                        mineLocations[i][1]
                    ].revealed = true;
                    setBoard(newBoardValues);

                    // }, 500);
                }
            }
            setGameOver(true);
        } else {
            // newBoardValues[x][y].revealed = true;
            newBoardValues = revealed(newBoardValues, x, y, newNonMinesCount);
            if (!newBoardValues) {
                return;
            }
            setBoard(newBoardValues.arr);
            setNonMinesCount(newBoardValues.newNonMinesCount);
        }
    };

    const flagCell = (x, y) => {
        let newBoardValues = JSON.parse(JSON.stringify(board));
        if((newBoardValues[x][y].flagged || flag !== 0) && !newBoardValues[x][y].revealed) {
            newBoardValues[x][y].flagged = !newBoardValues[x][y].flagged;
            setBoard(newBoardValues);
            newBoardValues[x][y].flagged ? setFlag(flag - 1) : setFlag(flag + 1);
        }
    };

    return (
        <>
            <div className="minesweeper-head">Minesweeper</div>
            <div
                style={{ boxShadow: "0 4px 3px rgba(0,0,0,0.3)", position: "relative" }}
            >
                {gameOver && <Modal reset={setRestart} completeTime={newTime} />}
                <TopBar gameOver={gameOver} setTime={setTime} newTime={newTime} setFlag={flag} />
                {board.map((row, inde) => {
                    return (
                        <div style={{ display: "flex" }} key={inde}>
                            {row.map((singleCell, index) => {
                                return (
                                    <Cell
                                        key={index}
                                        data={singleCell}
                                        updateBoard={updateBoard}
                                        flagCell={flagCell}
                                    />
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </>

    );
}